import { createFileRoute } from '@tanstack/react-router';
import { AccountPage } from '@/features/users';

export const Route = createFileRoute('/_auth/users/$userId')({
  component: AccountRoute,
});

function AccountRoute() {
  const { userId } = Route.useParams();
  return <AccountPage userId={userId} />;
}
